import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "CardScreen" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, {
      class: "CardScreen__Card",
      justify: "center",
      "min-height": "100px",
      dense: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drawCards.hand, (card) => {
          return (_openBlock(), _createBlock(_component_v_card, {
            key: card,
            width: "16%",
            "min-height": "100",
            "max-width": "150",
            elevation: "0"
          }, {
            default: _withCtx(() => [
              (card === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_img, { src: _ctx.back }, null, 8, ["src"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_v_img, {
                      src: _ctx.cardImage(card as keyof cardImageMapperIf)
                    }, null, 8, ["src"])
                  ]))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      class: "CardScreen__Result",
      justify: "center",
      dense: ""
    }, {
      default: _withCtx(() => [
        (_ctx.drawCards.judgeResult !== '')
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.drawCards.judgeResult), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}